import { render, staticRenderFns } from "./UniversityHomeList.vue?vue&type=template&id=63b064de&scoped=true"
import script from "./UniversityHomeList.vue?vue&type=script&lang=js"
export * from "./UniversityHomeList.vue?vue&type=script&lang=js"
import style0 from "./UniversityHomeList.vue?vue&type=style&index=0&id=63b064de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b064de",
  null
  
)

export default component.exports